import colors from './colors';
import { HorizontalLayoutUI } from './HorizontalLayout';

export type StepperProps = {
  current: number
  count: number
};

export const StepperUI: React.FC<StepperProps> = ({ current, count }) => {
  const width = (100 / count) - 1;
  return (
    <HorizontalLayoutUI justify="space-between" width="100%">
      {Array.from(new Array(count)).map((_, i) => {
        const selected = i <= current;
        return (
          <div
            key={i}
            style={{
              width: `${width}%`,
              height: '8px',
              backgroundColor: selected ? colors.chartreuse : colors.greige,
              borderRadius: '2px',
            }}
          />
        );
      })}
    </HorizontalLayoutUI>
  );
};
